import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import withLayout from "components/HoC/withLayout";
import StatusReportA from "components/request-document/talent/StatusReportA";
import StatusReportB from "components/request-document/talent/StatusReportB";
import StatusReportRequestForm from "components/request-document/talent/StatusReportRequestForm";
import { statusReportServiceId } from "libs/configs/constant";
import { STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { getOldDataSmartFormList, getPartFormList, getRequestDoc, getSmartFormList, getSmartFormOld, readRequestDoc } from "redux/modules/statusReportSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
}));

function StatusReportPage() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const { showReqeustDoc, smartDetail } = useSelector((state) => state.statusReport);
  const [openRequest, setOpenRequest] = useState(false);
  const { personalID } = useSelector((state) => state.personal.detail);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get('draftId');

  const handleRequestDocClsoe = () => {

    setOpenRequest(false)
  };
  const handleRequestDocSubmit = () => {
    dispatch(readRequestDoc(true));
  };


  useEffect(() => {
    showLoading();

    async function fetchData() {

      if (personalID) {
        await dispatch(getPartFormList({ smartserviceId: statusReportServiceId, personalId: personalID }));
        const res = await dispatch(getSmartFormList({ personalId: personalID, isRequest: true }));
        await dispatch(getRequestDoc({ smartserviceId: statusReportServiceId, currSmartServiceId: res.payload.smartserviceId }));
        if (draftId) {
          const res = await dispatch(getOldDataSmartFormList({ personalId: personalID, draftId: draftId }));
        }
        else {
          await dispatch(getSmartFormOld({ smartserviceIdNewFrom: res.payload.smartserviceId, personalId: personalID }));
        }
      }

      hideLoading();

      if (!draftId) {
        setOpenRequest(!showReqeustDoc);
      }

    }
    fetchData();

  }, [dispatch, showReqeustDoc, personalID])

  return (
    <>
      <StatusReportStep />


      <Dialog
        open={openRequest}
        onClose={handleRequestDocClsoe}
        maxWidth="lg"
      >
        <DialogContent>
          <StatusReportRequestForm
            onCancel={handleRequestDocClsoe}
            onSubmit={handleRequestDocSubmit}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default withLayout(StatusReportPage);


export { StatusReportPage as AdminStatusReportPage };


function StatusReportStep() {
  const { step } = useSelector((state) => state.statusReport);
  switch (step) {
    case STATUS_REPORT_STEP.STATUS_REPORT_STEP_A:
      return <StatusReportA />;
    case STATUS_REPORT_STEP.STATUS_REPORT_STEP_B:
      return <StatusReportB />;
    default:
      return <StatusReportA />;
  }
}

